import { useState, useEffect } from 'react';
import { apiRequest, trickleListObjects } from '../../utils/api';

function LoginForm({ onToggleForm }) {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    try {

        const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
            setError('');
        };

        const handleSubmit = async (e) => {
            e.preventDefault();
            setError('');
            setIsLoading(true);

            try {
                const result = await apiRequest('POST', '/api/index/login', formData);
                if (result.success == false) {
                    throw new Error(result.error);
                }
                const token = result.data.token;

                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify({
                    id: result.data.id,
                    name: result.data.name,
                    email: result.data.email
                }));

                window.dispatchEvent(new Event('storage'));
                window.location.href = '/books';
            } catch (err) {
                setError(err.message || '登入失敗');
                console.error('登入錯誤:', err);
            } finally {
                setIsLoading(false);
            }
        };

        return (
            <div className="auth-container" data-name="login-form">
                <h2 className="auth-title">登入</h2>
                {error && (
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4" role="alert" data-name="error-message">
                        {error}
                    </div>
                )}
                <form onSubmit={handleSubmit} className="auth-form">
                    <div>
                        <label htmlFor="email" className="block mb-2">電子郵件</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="input"
                            placeholder="請輸入電子郵件"
                            disabled={isLoading}
                            data-name="email-input"
                        />
                    </div>
                    <div>
                        <label htmlFor="password" className="block mb-2">密碼</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            className="input"
                            placeholder="請輸入密碼"
                            disabled={isLoading}
                            data-name="password-input"
                        />
                    </div>
                    <button 
                        type="submit" 
                        className="btn btn-primary mt-4 w-full"
                        disabled={isLoading}
                        data-name="submit-button"
                    >
                        {isLoading ? (
                            <div className="flex items-center justify-center">
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-black mr-2"></div>
                                登入中...
                            </div>
                        ) : '登入'}
                    </button>
                </form>
                <p className="text-center mt-4" data-name="register-link">
                    還沒有帳號？{' '}
                    <button 
                        onClick={onToggleForm} 
                        className="text-blue-600 hover:underline"
                        disabled={isLoading}
                    >
                        立即註冊
                    </button>
                </p>
            </div>
        );
    } catch (error) {
        console.error('登入表單錯誤:', error);
        reportError(error);
        return null;
    }
}

export default LoginForm;